import { api } from '@/api/client'

export type User = {
  id: string; email: string | null; pending_email: string | null; email_confirmed: boolean; name: string
  role: 'admin' | 'user'; status: 'pending' | 'active' | 'blocked'; totp_enabled: boolean
  requires_totp_setup: boolean; last_login_at: string | null; ai_budget_rub: string | null; delivery_status: string | null
}
export type UserPage = { items: User[]; total: number }
export type UsageRow = { month: string; kind: string; role: 'llm' | 'jev'; calls: number; prompt_tokens: number | null; completion_tokens: number | null; cost_rub: string | null; pending_count: number }
export type UserStats = {
  user_id: string; last_login_at: string | null
  data_counts: { sessions: number; sets: number; templates: number; metric_samples: number; inbody_scans: number; lab_results: number; files: number }
  usage: UsageRow[]; budget: { limit_rub: string | null; confirmed_rub: string | null; reserved_rub: string | null; remaining_rub: string | null; pending_count: number | null }; usage_available: boolean
}
export type RoleSettings = { base_url: string; model: string; base_url_source: string; model_source: string; key_set: boolean }
export type AdminAiSettings = {
  user_id: string | null; base_url_override: string | null; model_override: string | null; jev_base_url_override: string | null
  jev_model_override: string | null; jev_min_confidence: number | null; llm: RoleSettings; jev: RoleSettings
  effective_jev_min_confidence: number; jev_min_confidence_source: string
}

export const PAGE_SIZE = 20
export const usersKey = ['admin', 'users'] as const
export const deliveryLabel = (status: string | null) => status === 'sent' ? 'Отправлено' : status === 'failed' ? 'Ошибка отправки' : status === 'pending' ? 'Ожидает отправки' : status === 'cancelled' ? 'Отменено' : 'Нет данных о доставке'
export type UserPatch = Partial<Pick<User, 'name' | 'email' | 'role' | 'status' | 'ai_budget_rub'>>
export const apiUsers = {
  list: (search: string, offset: number) => api.get<UserPage>('/admin/users', { query: { search, offset, limit: PAGE_SIZE } }),
  get: (id: string) => api.get<User>(`/admin/users/${id}`),
  create: (body: { email: string; name: string; role: 'admin' | 'user'; ai_budget_rub: string | null }) => api.post<User>('/admin/users', body),
  patch: (id: string, body: UserPatch) => api.patch<User>(`/admin/users/${id}`, body),
  stats: (id: string) => api.get<UserStats>(`/admin/users/${id}/stats`),
  invite: (id: string) => api.post<User>(`/admin/users/${id}/invite`),
  resetPassword: (id: string) => api.post<{ ok: true }>(`/admin/users/${id}/reset-password`),
  resetTotp: (id: string, code: string) => api.post<{ ok: true }>(`/admin/users/${id}/reset-totp`, { code }),
}
